import {Distribution, _Distribution} from './distribution';

/**
 * Generated from com.dataiku.dip.eda.compute.distributions.LogNormal
 */
export interface LogNormal extends _Distribution {
    // PolyJson type
    type: 'lognormal';
}

export function isLogNormal(toTest: Distribution): toTest is LogNormal { return 'lognormal' === toTest.type; }

export namespace LogNormal {
    /**
     * Generated from com.dataiku.dip.eda.compute.distributions.LogNormal$FittedLogNormal
     */
    export interface FittedLogNormal extends Distribution._FittedDistribution {
        logmean: number;
        logstd: number;

        // PolyJson type
        type: 'lognormal';
    }

    export function isFittedLogNormal(toTest: Distribution.FittedDistribution): toTest is FittedLogNormal { return 'lognormal' === toTest.type; }
}